export const SUCCESS_200 = 200;
export const SUCCESS_201 = 201;

export const ERROR_500 = 500;
 
export const ERROR_CODE = {
  code_500: 500,
  code_501: 501,
  code_502: 502,
  code_503: 503,
  code_504: 504,
  code_505: 505,
  code_506: 506,
  code_507: 507,
  code_508: 508,
  code_509: 509,
  code_510: 510,
  code_511: 511,
};

export const ERROR_MESSAGE = 'Error interno';